// ErrorBoundary.js
import React from 'react';
import { View, Text, Button, ImageBackground, StyleSheet } from 'react-native';
import { COLOR_WHITE, FONT_FAMILY, FONT_FAMILY_BOLD, FONT_SIZE, FONT_SIZE_L } from "../constants/styleConstants";
import PropTypes from 'prop-types'; // If you're using PropTypes

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        // Log to an external error monitoring service here
    }

    handleTryAgain = () => {
        this.setState({ hasError: false, error: null });
        // Implement recovery logic here
    };

    render() {
        if (this.state.hasError) {
            return (
                <ImageBackground resizeMode='cover' source={require("../../assets/images/meeting-room-display-default.png")} style={styles.background}>
                    <View style={styles.container}>
                        <Text style={styles.title}>An error occurred</Text>
                        <Text style={styles.errorMessage}>{this.state.error?.message}</Text>
                        <Button title="Try Again" onPress={this.handleTryAgain} />
                    </View>
                </ImageBackground>
            );
        }

        return this.props.children;
    }
}

const styles = StyleSheet.create({
    background: { width: '100%', height: '100%' },
    container: { flex: 1, alignItems: 'center', justifyContent: 'center', margin: 100 },
    title: { fontSize: FONT_SIZE_L, fontWeight: 'bold', marginBottom: 10, color: COLOR_WHITE },
    errorMessage: { marginBottom: 20, color: COLOR_WHITE }
});